__webpack_require__.p = "/televet/_next/";